import React, { useState, useEffect, useRef } from "react";
import { mediaSrc } from "../utils/media";

const REELS = [
  {
    views: "124K",
    title: "Royal Anniversary Setup",
    tag: "Anniversary",
    video: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779220007/Make_your_anniversary_s_more_special_only_carnival_castle__Contact-_8341428342_carnivalcastle_ohoj2o.mp4",
  },
  {
    views: "89K",
    title: "Romantic Proposal",
    tag: "Romance",
    video: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779221238/Memorable_moment_%EF%B8%8F_proposal_couple_love_explore_memory_carnival_castle_Experience_the_mos_etnmec.mp4",
  },
  {
    views: "203K",
    title: "Birthday Celebration",
    tag: "Birthday",
    video: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779221257/Celebrate_your_event_carnival_castle__Contact-_8341428342_9059382797Experience_the_most_unique_qjnpzy.mp4",
  },
  {
    views: "67K",
    title: "Bride To Be",
    tag: "Luxury",
    video: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779221682/Bride_To_Be_Celebration_in_Hyderabad_-_Budget-Friendly_Luxury_Private_Party_Venue_Plannin_pnqc3y.mp4",
  },
  {
    views: "156K",
    title: "Kids Theme Party",
    tag: "Kids Party",
    video: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779222121/Celebrate_Lakshith_s_1st_Birthday_in_a_joyful_and_magical_way_at_Carnival_Castle_Private_Theatre_bupm9c.mp4",
  },
  {
    views: "91K",
    title: "Movies",
    tag: "Movie preview",
    video: "https://res.cloudinary.com/dt3jzl980/video/upload/v1779221809/Hero_Suman_Prabhas_laanti_celebrities_ki_telisina_Carnival_Castle_Celebrities_trust_chesina_ce_sequks.mp4",
  },
];

const CARD_W = 260;
const GAP    = 20;
const STEP   = CARD_W + GAP;

export default function InstagramReelsSection() {
  const [idx,     setIdx]     = useState(0);
  const [hovered, setHovered] = useState(false);
  const timerRef = useRef(null);

  /* ── visible count based on viewport ── */
  const [visCount, setVisCount] = useState(4);
  useEffect(() => {
    const update = () => {
      const w = window.innerWidth;
      setVisCount(w < 540 ? 1 : w < 768 ? 2 : w < 1100 ? 3 : 4);
    };
    update();
    window.addEventListener("resize", update);
    return () => window.removeEventListener("resize", update);
  }, []);

  const maxIdx = REELS.length - visCount;

  /* ── auto-slide ── */
  const startTimer = () => {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(() => {
      setIdx(i => (i >= maxIdx ? 0 : i + 1));
    }, 3000);
  };

  useEffect(() => {
    if (!hovered) startTimer();
    else clearInterval(timerRef.current);
    return () => clearInterval(timerRef.current);
  }, [hovered, maxIdx]);

  const prev = () => { setIdx(i => Math.max(0, i - 1)); startTimer(); };
  const next = () => { setIdx(i => (i >= maxIdx ? 0 : i + 1)); startTimer(); };

  const translateX = -(idx * STEP);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700;900&family=DM+Sans:wght@300;400;500;600;700&display=swap');

        :root {
          --dark:  #120020;
          --dark2: #1A0030;
          --p:     #5E0E73;
          --pl:    #6E1A85;
          --gold:  #C9A84C;
          --gl:    #E8D5A0;
          --gb:    #F5D87A;
        }

        /* ─── keyframes ─── */
        @keyframes rl-goldBg {
          0%,100% { background-position: 0% 50%; }
          50%      { background-position: 100% 50%; }
        }
        @keyframes rl-shine {
          0%   { left: -100%; }
          25%  { left: 130%; }
          100% { left: 130%; }
        }
        @keyframes rl-fadeUp {
          from { opacity: 0; transform: translateY(28px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        @keyframes rl-float {
          0%,100% { transform: translateY(0); }
          50%      { transform: translateY(-10px); }
        }
        @keyframes rl-pulse {
          0%,100% { opacity: .4; transform: scale(1); }
          50%      { opacity: .8; transform: scale(1.08); }
        }

        /* ─── section ─── */
        .rl-section {
          padding: 100px 0 110px;
          background: var(--dark);
          overflow: hidden;
          position: relative;
          font-family: 'DM Sans', sans-serif;
        }

        /* decorative orbs */
        .rl-orb {
          position: absolute;
          border-radius: 50%;
          filter: blur(80px);
          pointer-events: none;
          animation: rl-pulse 6s ease-in-out infinite;
        }

        /* noise grain overlay */
        .rl-section::after {
          content: '';
          position: absolute;
          inset: 0;
          background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 256 256' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='.9' numOctaves='4' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)' opacity='.03'/%3E%3C/svg%3E");
          pointer-events: none;
          opacity: .4;
        }

        .rl-container {
          width: min(1320px, 92%);
          margin: auto;
          position: relative;
          z-index: 2;
        }

        /* ─── header ─── */
        .rl-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-end;
          margin-bottom: 52px;
          flex-wrap: wrap;
          gap: 20px;
          animation: rl-fadeUp .8s cubic-bezier(.16,1,.3,1) both;
        }

        .rl-header-left {}

        .rl-eyebrow {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          color: var(--gl);
          font-size: 11px;
          font-weight: 700;
          letter-spacing: 3px;
          text-transform: uppercase;
          margin-bottom: 14px;
        }
        .rl-eyebrow-line {
          width: 32px;
          height: 1px;
          background: var(--gold);
          opacity: .6;
        }

        .rl-title {
          font-family: 'Playfair Display', serif;
          font-size: clamp(32px, 5vw, 54px);
          font-weight: 900;
          color: #fff;
          line-height: 1.08;
          margin: 0 0 10px;
          letter-spacing: -.5px;
        }
        .rl-title em {
          font-style: italic;
          color: var(--gold);
        }

        .rl-sub {
          color: rgba(255,255,255,.5);
          font-size: 15px;
          line-height: 1.6;
          max-width: 400px;
        }

        /* ─── nav arrows ─── */
        .rl-nav {
          display: flex;
          gap: 12px;
          align-items: center;
        }
        .rl-nav-btn {
          width: 46px;
          height: 46px;
          border-radius: 50%;
          background: rgba(255,255,255,.06);
          border: 1.5px solid rgba(255,255,255,.14);
          color: #fff;
          font-size: 20px;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          transition: all .25s;
          font-weight: 700;
          flex-shrink: 0;
        }
        .rl-nav-btn:hover {
          background: var(--gold);
          color: var(--dark);
          border-color: var(--gold);
          transform: scale(1.08);
        }

        /* ─── carousel ─── */
        .rl-carousel-wrap {
          overflow: hidden;
          width: 100%;
        }

        .rl-track {
          display: flex;
          gap: ${GAP}px;
          transition: transform .65s cubic-bezier(.25,1,.5,1);
          will-change: transform;
        }

        /* ─── card ─── */
        .rl-card {
          position: relative;
          width: ${CARD_W}px;
          min-width: ${CARD_W}px;
          height: 470px;
          border-radius: 26px;
          overflow: hidden;
          background: #000;
          border: 1px solid rgba(255,255,255,.07);
          transition: transform .4s cubic-bezier(.25,1,.5,1), box-shadow .4s, border-color .4s;
          flex-shrink: 0;
          cursor: pointer;
        }
        .rl-card:hover {
          transform: translateY(-10px) scale(1.02);
          border-color: rgba(201,168,76,.5);
          box-shadow: 0 30px 70px rgba(0,0,0,.55), 0 0 40px rgba(201,168,76,.1);
        }

        /* ─── video ─── */
        .rl-video {
          position: absolute;
          inset: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          object-position: center;
          display: block;
        }

        /* ─── gradient overlay ─── */
        .rl-overlay {
          position: absolute;
          inset: 0;
          background: linear-gradient(
            to top,
            rgba(13,0,24,.95) 0%,
            rgba(13,0,24,.4)  45%,
            rgba(13,0,24,.08) 100%
          );
          pointer-events: none;
        }

        /* ─── views badge ─── */
        .rl-views {
          position: absolute;
          top: 14px;
          left: 14px;
          z-index: 5;
          padding: 5px 11px;
          border-radius: 999px;
          background: rgba(0,0,0,.5);
          backdrop-filter: blur(12px);
          border: 1px solid rgba(255,255,255,.12);
          color: #fff;
          font-size: 11px;
          font-weight: 700;
          font-family: 'DM Sans', sans-serif;
          display: flex;
          align-items: center;
          gap: 5px;
        }

        /* ─── play button ─── */
        .rl-play {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%) scale(.85);
          z-index: 5;
          width: 52px;
          height: 52px;
          border-radius: 50%;
          background: rgba(201,168,76,.9);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 18px;
          opacity: 0;
          transition: all .3s;
          box-shadow: 0 8px 28px rgba(201,168,76,.5);
        }
        .rl-card:hover .rl-play {
          opacity: 1;
          transform: translate(-50%, -50%) scale(1);
        }

        /* ─── bottom info ─── */
        .rl-info {
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          z-index: 5;
          padding: 20px 18px 22px;
        }

        .rl-tag-pill {
          display: inline-block;
          background: rgba(201,168,76,.2);
          border: 1px solid rgba(201,168,76,.45);
          color: var(--gold);
          font-size: 9px;
          font-weight: 800;
          letter-spacing: 1.5px;
          text-transform: uppercase;
          padding: 3px 10px;
          border-radius: 50px;
          margin-bottom: 8px;
        }

        .rl-info h3 {
          margin: 0;
          color: #fff;
          font-family: 'Playfair Display', serif;
          font-size: 17px;
          font-weight: 700;
          line-height: 1.3;
        }

        /* ─── gold shimmer border on hover ─── */
        .rl-card::after {
          content: '';
          position: absolute;
          inset: 0;
          border-radius: 26px;
          border: 1.5px solid transparent;
          background: linear-gradient(135deg, rgba(201,168,76,.6), transparent 60%) border-box;
          -webkit-mask: linear-gradient(#fff 0 0) padding-box, linear-gradient(#fff 0 0);
          -webkit-mask-composite: destination-out;
          mask-composite: exclude;
          opacity: 0;
          transition: opacity .4s;
          pointer-events: none;
        }
        .rl-card:hover::after { opacity: 1; }

        /* ─── dots ─── */
        .rl-dots {
          display: flex;
          gap: 8px;
          justify-content: center;
          margin-top: 36px;
        }
        .rl-dot {
          height: 8px;
          border-radius: 4px;
          background: rgba(255,255,255,.2);
          border: none;
          cursor: pointer;
          transition: all .4s;
        }
        .rl-dot.active {
          width: 28px !important;
          background: linear-gradient(90deg, var(--gold), var(--gl));
        }

        /* ─── bottom CTA strip ─── */
        .rl-cta-strip {
          margin-top: 52px;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 16px;
          flex-wrap: wrap;
          animation: rl-fadeUp .8s cubic-bezier(.16,1,.3,1) .3s both;
        }

        .rl-btn-gold {
          position: relative;
          overflow: hidden;
          background: linear-gradient(135deg, #B8860B, var(--gold), var(--gb), var(--gold), #9A6E10);
          background-size: 200% 200%;
          animation: rl-goldBg 3s ease infinite;
          color: var(--dark);
          border: none;
          border-radius: 50px;
          padding: 13px 30px;
          font-weight: 800;
          font-size: 14px;
          cursor: pointer;
          box-shadow: 0 6px 24px rgba(201,168,76,.4);
          display: inline-flex;
          align-items: center;
          gap: 8px;
          font-family: 'DM Sans', sans-serif;
          transition: transform .3s, box-shadow .3s;
          text-decoration: none;
        }
        .rl-btn-gold::before {
          content: '';
          position: absolute;
          top: 0;
          left: -100%;
          width: 55%;
          height: 100%;
          background: linear-gradient(90deg, transparent, rgba(255,255,255,.4), transparent);
          animation: rl-shine 3s ease infinite;
        }
        .rl-btn-gold:hover {
          transform: translateY(-2px);
          box-shadow: 0 12px 32px rgba(201,168,76,.55);
        }

        .rl-btn-ig {
          display: inline-flex;
          align-items: center;
          gap: 9px;
          border: 1.5px solid rgba(255,255,255,.2);
          background: rgba(255,255,255,.05);
          backdrop-filter: blur(8px);
          color: #fff;
          border-radius: 50px;
          padding: 12px 28px;
          font-weight: 700;
          font-size: 14px;
          cursor: pointer;
          font-family: 'DM Sans', sans-serif;
          text-decoration: none;
          transition: all .3s;
        }
        .rl-btn-ig:hover {
          border-color: rgba(201,168,76,.5);
          background: rgba(201,168,76,.08);
          color: var(--gold);
          transform: translateY(-2px);
        }

        /* ─── responsive ─── */
        @media(max-width:768px) {
          .rl-section  { padding: 70px 0 80px; }
          .rl-header   { margin-bottom: 36px; }
          .rl-title    { font-size: clamp(28px,7vw,38px); }
          .rl-nav      { margin-top: 4px; }
        }

        @media(max-width:540px) {
          .rl-card { height: 420px; }
          .rl-info h3 { font-size: 15px; }
          .rl-nav-btn { width: 40px; height: 40px; font-size: 17px; }
        }
      `}</style>

      <section className="rl-section">

        {/* decorative orbs */}
        <div className="rl-orb" style={{ width:460, height:460, background:"radial-gradient(circle,rgba(94,14,115,.28) 0%,transparent 70%)", top:-80, left:-80, animationDelay:"0s" }} />
        <div className="rl-orb" style={{ width:320, height:320, background:"radial-gradient(circle,rgba(201,168,76,.1) 0%,transparent 70%)", bottom:-60, right:-40, animationDelay:"3s" }} />

        <div className="rl-container">

          {/* ── HEADER ── */}
          <div className="rl-header">
            <div className="rl-header-left">
              <div className="rl-eyebrow">
                <div className="rl-eyebrow-line" />
                Celebrations in Action
                <div className="rl-eyebrow-line" />
              </div>
              <h2 className="rl-title">
                Watch the <em>Celebrations</em><br />Come Alive
              </h2>
              <p className="rl-sub">
                Watch real celebrations, real emotions, and unforgettable moments at Carnival Castle.
              </p>
            </div>

            <div className="rl-nav">
              <button className="rl-nav-btn" onClick={prev} aria-label="Previous">‹</button>
              <button className="rl-nav-btn" onClick={next} aria-label="Next">›</button>
            </div>
          </div>

          {/* ── CAROUSEL ── */}
          <div
            className="rl-carousel-wrap"
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
          >
            <div
              className="rl-track"
              style={{ transform: `translateX(${translateX}px)` }}
            >
              {REELS.map((reel, i) => (
                <div key={i} className="rl-card">
                  <video
                    className="rl-video"
                    src={mediaSrc(reel.video, { w: 540 })}
                    autoPlay
                    muted
                    loop
                    playsInline
                    preload="auto"
                  />
                  <div className="rl-overlay" />
                  <div className="rl-views">👁 {reel.views}</div>
                  <div className="rl-play">▶</div>
                  <div className="rl-info">
                    <div className="rl-tag-pill">{reel.tag}</div>
                    <h3>{reel.title}</h3>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* ── DOTS ── */}
          <div className="rl-dots">
            {Array.from({ length: REELS.length - visCount + 1 }).map((_, i) => (
              <button
                key={i}
                className={`rl-dot${i === idx ? " active" : ""}`}
                style={{ width: i === idx ? 28 : 8 }}
                onClick={() => { setIdx(i); startTimer(); }}
                aria-label={`Slide ${i + 1}`}
              />
            ))}
          </div>

          {/* ── CTA STRIP ── */}
          <div className="rl-cta-strip">
            <a
              href="https://www.instagram.com/carnival_castle_/"
              target="_blank"
              rel="noopener noreferrer"
              className="rl-btn-ig"
            >
              <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
                <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
              </svg>
              Follow @carnivalcastle
            </a>
            <a
              href="https://wa.me/918374777834"
              target="_blank"
              rel="noopener noreferrer"
              className="rl-btn-gold"
            >
              🎉 Book Your Celebration
            </a>
          </div>

        </div>
      </section>
    </>
  );
}